





















































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AsesmenPraSedaDetail extends Vue {
  @Prop() readonly data!: any;

  riwayatPenyakit = [
    { key: "rp_hipertensi", label: "Hipertensi" },
    { key: "rp_penyakit_jantung", label: "Penyakit Jantung" },
    { key: "rp_asthma", label: "Asthma" },
    { key: "rp_tbc_ppok", label: "TBC/PPOK" },
    { key: "rp_dm", label: "DM" },
    { key: "rp_stroke_tia", label: "Stroke/TIA" },
    { key: "rp_merokok", label: "Merokok" },
    { key: "rp_alergi", label: "Alergi" }
  ];

  asaDescriptions: Record<string, string> = {
    I: "Pasien sehat",
    II: "Gangguan sistemik ringan",
    III: "Gangguan sistemik berat, tidak mengancam jiwa",
    IV: "Gangguan sistemik berat, mengancam jiwa",
    V: "Moribund",
    VI: "Mati otak (donor organ)"
  };

  get asaDesc(): string {
    return this.asaDescriptions[this.data?.asa_klasifikasi] || "";
  }

  get asaColor(): string {
    const map: Record<string, string> = {
      I: "green", II: "blue", III: "orange",
      IV: "red darken-1", V: "red darken-4", VI: "black"
    };
    return map[this.data?.asa_klasifikasi] || "grey";
  }

  get teknikSummary(): string {
    const parts: string[] = [];
    if (this.data.teknik_sedasi) parts.push("Sedasi");
    if (this.data.teknik_ga) parts.push("GA");
    if (this.data.teknik_spinal) parts.push("Spinal");
    if (this.data.teknik_epidural) parts.push("Epidural");
    if (this.data.teknik_kaudal) parts.push("Kaudal");
    if (this.data.teknik_blok_perifer) parts.push("Blok Perifer");
    return parts.length > 0 ? parts.join(", ") : "-";
  }

  get hasAnyTeknikKhusus(): boolean {
    return this.data.tk_hipotensi || this.data.tk_ventilasi_satu_paru
      || this.data.tk_tci || this.data.tk_lainnya;
  }

  get teknikKhususSummary(): string {
    const parts: string[] = [];
    if (this.data.tk_hipotensi) parts.push("Hipotensi terkontrol");
    if (this.data.tk_ventilasi_satu_paru) parts.push("Ventilasi Satu Paru");
    if (this.data.tk_tci) parts.push("TCI");
    if (this.data.tk_lainnya) parts.push(this.data.tk_lainnya_text || "Lain-lain");
    return parts.join(", ");
  }

  get monitorSummary(): string {
    const parts: string[] = [];
    if (this.data.mon_ekg) parts.push(`EKG${this.data.mon_ekg_lead ? ' Lead ' + this.data.mon_ekg_lead : ''}`);
    if (this.data.mon_spo2) parts.push("SpO\u2082");
    if (this.data.mon_nibp) parts.push("NIBP");
    if (this.data.mon_temperatur) parts.push("Temperatur");
    if (this.data.mon_arteri_line) parts.push("Arteri Line");
    if (this.data.mon_cvp) parts.push("CVP");
    if (this.data.mon_etco2) parts.push("EtCO\u2082");
    if (this.data.mon_bis) parts.push("BIS");
    return parts.length > 0 ? parts.join(", ") : "-";
  }

  get pascaLabel(): string {
    const map: Record<string, string> = {
      rawat_jalan: "Rawat Jalan",
      rawat_inap: "Rawat Inap",
      icu: "ICU"
    };
    return map[this.data?.pasca_anestesi] || "-";
  }
}
